import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import TitlePage from 'components/atoms/title-page';
import { ALERT_TYPES } from 'constants/alert-constants';
import AdminsApiV3 from 'api/v3/admins-api-v3';
import AdminUpdatePasswordForm from 'domains/admin/organisms/admin-update-password-form';


const propTypes = {
  pageUtils: PropTypes.shape({
  setAlertMsg: PropTypes.func,
  setApiErrorMsg: PropTypes.func,
  }),
};


const UpdatePasswordPage = ({ pageUtils }) => {
const handleSubmitForm = async (values, formikBag) => {
  try {
    await AdminsApiV3.updatePassword({
      current_password: values.current_password,
      new_password: values.new_password,
      password_confirmation: values.password_confirmation,
    });
    pageUtils.setAlertMsg('Password has been changed.', ALERT_TYPES.SUCCESS);
    formikBag.resetForm();
  } catch (error) {
      const { response } = error || {};
      const messages = response?.data?.messages || { base: [response?.data?.error || 'Failed'] };
      formikBag.setErrors(messages);
      pageUtils.setApiErrorMsg(response?.data || { error: error.message });
    }
  };

  const handleResetPassword = async () => {
    try {
      const { data } = await AdminsApiV3.resetPassword()
      // tampilkan info
      pageUtils.setAlertMsg(data?.message || 'Temporary password created. Please login again.', ALERT_TYPES.SUCCESS)
      // jika di dev/test server mengembalikan temp password, tampilkan sekali
      if (data?.temporary_password) {
        window.prompt('Copy your one-time temporary password:', data.temporary_password)
      }
      // paksa logout lalu ke halaman login
      await AdminsApiV3.logout()
      window.location.assign('/admin/login')
    } catch (error) {
      pageUtils.setApiErrorMsg(error.response?.data || { error: error.message })
    }
  }


  return (
  <>
    <TitlePage mainTitle={'Update'} subTitle={'Password'} />
    <Card body>
      <AdminUpdatePasswordForm
        handleSubmitForm={handleSubmitForm} 
        onResetPassword={ handleResetPassword }
      />
    </Card>
  </>
  );

};

UpdatePasswordPage.propTypes = propTypes;
export default UpdatePasswordPage;
